import { jsx as e } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { B as n } from "../Button-C2yT_E3v.js";
const m = i(({ active: r, isRounded: t = !0, ...a }, o) => /* @__PURE__ */ e(
  n,
  {
    "aria-pressed": r,
    "data-cxy-name": "pill",
    "data-state": r ? "on" : "off",
    ref: o,
    rounded: t,
    variant: r ? "active" : "tertiary",
    ...a
  }
));
m.displayName = "Pill";
export {
  m as Pill
};
